import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

function ButtonSpinner() {
  return <CircularProgress color="inherit" size={16} style={{ marginRight: 5 }} />
}

export default ButtonSpinner